import { userDetails } from "@/types";
import { create } from "zustand";
import { Agency, Brand } from "@/app/(protected)/raise-request/types";
import { BrandMarketsAgency } from "@/app/(protected)/manage-users/types";

interface UserState {
  userData?: userDetails | null;
  setUserData: (data: userDetails) => void;
  brands: Brand[];
  agencies: Agency[];
  agencyBrands: BrandMarketsAgency[];
  isCurrentUserAgencyBrandAdmin: boolean;
  setBrands: (brands: Brand[]) => void;
  setAgencies: (agencies: Agency[]) => void;
  setAgencyBrands: (agencyBrands: BrandMarketsAgency[]) => void;
  setIsCurrentUserAgencyBrandAdmin: (val: boolean) => void;
}

export const useUserStore = create<UserState>((set) => ({
  userData: null,
  setUserData: (data: userDetails) => set({ userData: data }),
  brands: [],
  agencies: [],
  agencyBrands: [],
  isCurrentUserAgencyBrandAdmin: false,
  setBrands: (brands: Brand[]) => set({ brands }),
  setAgencies: (agencies: Agency[]) => set({ agencies }),
  setAgencyBrands: (agencyBrands: BrandMarketsAgency[]) => set({ agencyBrands }),
  setIsCurrentUserAgencyBrandAdmin: (val: boolean) => set({ isCurrentUserAgencyBrandAdmin: val }),
}));
